import '../stylesheets/main.scss';

import htmx from 'htmx.org';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

// Alpine.js directives
// See https://alpinejs.dev/advanced/extending#custom-directives
import ResizeObserverDirective from './directives/resizeobserver';

// Alpine.js components
// See https://alpinejs.dev/globals/alpine-data#registering-from-a-bundle
import PasswordComponent from '../components/password/javascripts/index';
import ScrollContainerComponent from '../components/scroll-container/javascripts/index';
import FileUploadComponent from '../components/file-upload/javascripts/index';
import VideoComponent from '../components/video/javascripts/index';
import DialogComponent from '../components/dialog/javascripts/index';
import TabsComponent from '../components/tabs/javascripts/index';
import SliderComponent from '../components/slider/slider';
import GalleryComponent from '../components/gallery/gallery';
import SpeakersListComponent from '../components/speakers-list/speakers-list';
import MarqueeComponent from '../components/marquee/marquee';
import FeeCalculatorComponent from '../components/fee-calculator/fee-calculator';
import EventStageComponent from '../components/event-stage/javascripts/index';
import EventListComponent from '../components/event-list/javascripts/index';
import NavigationComponent from '../components/navigation/navigation';
import SearchDialogComponent from '../components/search-dialog/search-dialog';
import SearchListComponent from '../components/search-list/javascripts/search-list';

// Alpine.js initialization
// See https://alpinejs.dev/essentials/installation#as-a-module
window.Alpine = Alpine;

// htmx initialization
// See https://htmx.org/docs/#webpack
window.htmx = htmx;

Alpine.plugin(collapse);
Alpine.directive('resizeobserver', ResizeObserverDirective);

Alpine.data('Password', PasswordComponent);
Alpine.data('ScrollContainer', ScrollContainerComponent);
Alpine.data('FileUpload', FileUploadComponent);
Alpine.data('Video', VideoComponent as any);
Alpine.data('Dialog', DialogComponent);
Alpine.data('Tabs', TabsComponent);
Alpine.data('Slider', SliderComponent);
Alpine.data('Gallery', GalleryComponent);
Alpine.data('FeeCalculator', FeeCalculatorComponent);
Alpine.data('SpeakersList', SpeakersListComponent as any);
Alpine.data('Marquee', MarqueeComponent);
Alpine.data('EventStage', EventStageComponent as any);
Alpine.data('EventList', EventListComponent as any);
Alpine.data('Navigation', NavigationComponent as any);
Alpine.data('SearchDialog', SearchDialogComponent as any);
Alpine.data('SearchList', SearchListComponent as any);

Alpine.store('general', {
  isSearchOpen: false,
  // Navigation
  isNavOpen: false,

  toggleSearch(state?: boolean) {
    this.isNavOpen = false;
    this.isSearchOpen =
      typeof state !== 'undefined' ? state : !this.isSearchOpen;
  },
  toggleNav(state?: boolean) {
    this.isSearchOpen = false;
    this.isNavOpen = typeof state !== 'undefined' ? state : !this.isNavOpen;
  }
} as any);

Alpine.start();

// All links with target="_blank" attribute should have an attribute rel="noopener". This has performance and security reasons https://developers.google.com/web/tools/lighthouse/audits/noopener
document.querySelectorAll("[target='_blank']").forEach((link) => {
  link.setAttribute('rel', 'noopener');
});

const lightbox = new PhotoSwipeLightbox({
  gallery: 'body',
  children: 'a[data-pswp]',
  showHideAnimationType: 'fade',
  pswpModule: () => import('photoswipe')
});

lightbox.init();

['beforeprint', 'afterprint'].forEach((ev) =>
  window.addEventListener(ev, () => {
    document
      .querySelectorAll('details')
      ?.forEach((el) => el.toggleAttribute('open'));
  })
);
